import { useState } from "react";
import { api } from "@/lib/api";
import { PLAN_NAMES } from "@/lib/plans";
import { captureError } from "@/lib/sentry";

const fmtDate = (iso, lang) => (iso ? new Date(iso).toLocaleDateString(lang === "es" ? "es-MX" : "en-US", { month: "long", day: "numeric", year: "numeric" }) : "");

// Current subscription summary + cancel / resume / manage billing.
export default function BillingPanel({ billing, copy, lang, onChange }) {
  const [busy, setBusy] = useState(null);
  if (!billing || billing.plan === "free") return null;
  const c = copy.billing;

  const call = async (key, fn) => {
    setBusy(key);
    try {
      await fn();
      await onChange();
    } catch (err) {
      captureError(`billing ${key} failed:`, err);
    } finally {
      setBusy(null);
    }
  };
  const toggleCancel = () => call("cancel", () => api.post("/payments/cancel", { resume: billing.cancel_at_period_end }));
  const portal = () => call("portal", async () => {
    const r = await api.post("/payments/portal", { origin_url: window.location.origin });
    window.location.href = r.data.url;
  });

  return (
    <div className="mb-8 p-5 rounded-md bg-[#121212] border border-white/10 flex flex-col md:flex-row md:items-center gap-4" data-testid="billing-panel">
      <div className="flex-1">
        <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/45">{c.title}</p>
        <p className="font-display font-bold text-2xl uppercase tracking-tight" data-testid="billing-plan">{PLAN_NAMES[billing.plan]}</p>
        {billing.has_subscription ? (
          <p className="text-sm text-white/60" data-testid="billing-period">
            {billing.cancel_at_period_end ? c.ends : c.renews} {fmtDate(billing.current_period_end, lang)}
          </p>
        ) : (
          <p className="text-sm text-white/60" data-testid="billing-demo-note">{billing.comp_access ? c.comp : c.demo}</p>
        )}
        {billing.subscription_status === "past_due" && <p className="text-sm text-[#FF453A] mt-1" data-testid="billing-past-due">{c.pastDue}</p>}
      </div>
      {billing.has_subscription && (
        <div className="flex flex-wrap gap-2">
          <button
            onClick={toggleCancel}
            disabled={!!busy}
            data-testid={billing.cancel_at_period_end ? "billing-resume-btn" : "billing-cancel-btn"}
            className="px-4 py-2 rounded-md border border-white/15 text-xs font-bold uppercase tracking-wider text-white/80 hover:text-white hover:border-white/30 disabled:opacity-50"
          >
            {billing.cancel_at_period_end ? c.resume : c.cancel}
          </button>
          <button
            onClick={portal}
            disabled={!!busy}
            data-testid="billing-portal-btn"
            className="px-4 py-2 rounded-md bg-white/10 hover:bg-white/20 text-xs font-bold uppercase tracking-wider disabled:opacity-50"
          >
            {c.manage}
          </button>
        </div>
      )}
    </div>
  );
}
